/* eslint-disable no-irregular-whitespace */
export const afdDetails = {
	id: '1',
	dealTtype: 'Afd',
	promoCode: '',
	vendorLink: 'https://www.fitbit.com/global/us/store/choosehealthy',
	dealName: 'Active&Fit',
	cardTitle: 'Card Title: Active&Fit',
	detailsLogo: {
		fileName: 'sup',
		url: 'https://www.choosehealthy.com//cdn/0002468_0.png',
	},
	detailsIntro: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"The Active&Fit Direct program is designed to help you achieve better health through regular exercise, wherever you are. The program gives you access to 12,200+ fitness centers nationwide and 9,700+ digital workout videos for just $28/month (plus an enrollment fee and applicable taxes)! You can also join any of our 5,800+ premium exercise studios with 20% – 70% discounts on most, and purchase an additional membership for your spouse.","marks":[]}]}]}`,
	detailsTitle:
		'Stay active at the Gym or at Home for Just $28/Month - No Long-Term Contracts',
	detailsHeroImage: {
		name: 'AFD Deal Hero Image',
		altText: 'altText: AFD Deal Hero Image',
		imageXs: {
			fileName: 'Card Nutritional Services',
			url: 'https://material-ui.com/static/images/cards/contemplative-reptile.jpg',
			width: 960,
			height: 540,
		},
		imageSm: null,
		imageMd: null,
	},
	detailsHeroVideo: {
		fileName: 'mp4 sample',
		url: 'https://videos.ctfassets.net/1g6by23er3py/zEkbKjJxO9rHDscAMpynG/b08861b93d17c1854a72534c5d581c8f/file_example_MP4_480_1_5MG.mp4',
	},
	detailsDescriptionTitle: 'Why The Active&Fit Program?',
	detailsDescription: `{
		"nodeType": "document",
		"data": {
		  "target": null
		},
		"content": [
		  {
			"nodeType": "unordered-list",
			"data": {
			  "target": null
			},
			"content": [
			  {
				"nodeType": "list-item",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "12,200+ Standard fitness centers, with the ability to change anytime, for just $28/month*​",
						"marks": []
					  }
					]
				  }
				]
			  },
			  {
				"nodeType": "list-item",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "\\r5,800+ Premium exercise studios and fitness centers with 20% – 70% discounts on most​\\r",
						"marks": []
					  }
					]
				  }
				]
			  },
			  {
				"nodeType": "list-item",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "9,700+ digital workout videos so you can work out at home or on-the-go\\r",
						"marks": []
					  }
					]
				  }
				]
			  },
			  {
				"nodeType": "list-item",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "Activity tracking with 250+ wearable trackers and apps\\r",
						"marks": []
					  }
					]
				  }
				]
			  },
			  {
				"nodeType": "list-item",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "Purchase an additional membership for your spouse**​\\r",
						"marks": []
					  }
					]
				  }
				]
			  },
			  {
				"nodeType": "list-item",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "No long-term contracts",
						"marks": []
					  }
					]
				  }
				]
			  }
			]
		  },
		  {
			"nodeType": "paragraph",
			"data": {
			  "target": null
			},
			"content": [
			  {
				"nodeType": "text",
				"data": {
				  "target": null
				},
				"value": "",
				"marks": []
			  }
			]
		  }
		]
	  }`,
	detailsContentTitleImageWidget: [
		{
			title: 'Standard & Premium Fitness centers including:',
			image: {
				name: 'AFD Deal content Image',
				altText: 'altText:AFD Deal content Image',
				imageXs: {
					fileName: 'Card Nutritional Services',
					url: 'https://images.ctfassets.net/1g6by23er3py/1T0dPVmVABHTlC0HVlw1k4/9bd8792c0edf8d41b1821e68fcfd628b/Capture.PNG',
					width: 960,
					height: 540,
				},
				imageSm: null,
				imageMd: null,
			},
		},
	],
	detailsDisclaimer: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"*Plus an enrollment fee and applicable taxes. Fees may vary based on fitness center selection.**Add a spouse/domestic partner to a primary membership for additional monthly fees. Spouses/domestic partners must be 18 years or older. Fees may vary based on fitness center selection.","marks":[{"type":"subscript"}]}]}]}`,
};

export const howToSectionConfig = {
	cardTitle: 'Card Title: Echelon',
	howToSectionStep1CustomText: '',
	promoCodeType: 'none',
	promoCode: '',
};

export const vendorDetails = {
	...howToSectionConfig,
	id: '1',
	dealType: 'vendor',
	vendorLink: 'https://www.fitbit.com/global/us/store/choosehealthy',
	dealName: 'Echelon',
	detailsLogo: {
		fileName: 'Echelon logo',
		url: 'https://www.choosehealthy.com//cdn/0002232_0.png',
	},
	detailsIntro: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Connected/Digital Fitness Products","marks":[]}]}]}`,
	detailsTitle: 'Save up to 30%, Free Freight and Financing!',
	detailsHeroImage: {
		name: 'Vendor Deal Hero Image',
		altText: 'altText: Vendor Deal Hero Image',
		imageXs: {
			fileName: 'Card Nutritional Services',
			url: 'https://material-ui.com/static/images/cards/contemplative-reptile.jpg',
			width: 960,
			height: 540,
		},
		imageSm: null,
		imageMd: null,
	},
	detailsDescriptionTitle: 'Echelon',
	detailsDescription: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Titanium","marks":[{"type":"bold"}]},{"nodeType":"text","data":{"target":null},"value":": The lightweight and comfortable Trekz Titanium wireless stereo headphones are the safest alternative to traditional sport headphones and earbuds. ","marks":[]}]},{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Air","marks":[{"type":"bold"}]},{"nodeType":"text","data":{"target":null},"value":": The next generation of bone conduction technology is what’s inside our lightest and most organically designed open-ear headphones to date. ","marks":[]}]},{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Aeropex","marks":[{"type":"bold"}]},{"nodeType":"text","data":{"target":null},"value":": Pushing the boundaries of open-ear listening, we’ve implemented brand new PremiumPitch 2.0+ and angled the transducers to ensure optimal placement on the cheekbones, allowing for more dynamic bass, higher volume and less vibration ","marks":[]}]},{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Xtrainerz","marks":[{"type":"bold"}]},{"nodeType":"text","data":{"target":null},"value":": Enjoy eight hours of premium audio with the fully waterproof Xtrainerz.","marks":[]}]}]}`,
};

export const specialtyDetails = {
	id: '1',
	promoCode: '',
	vendorLink: 'https://www.fitbit.com/global/us/store/choosehealthy',
	dealType: 'specialty',
	detailsTitle: 'Acupuncture',
	detailsHeroImage: {
		name: 'Specialty Deal Hero Image',
		altText: 'altText: Specialty Deal Hero Image',
		imageXs: {
			fileName: 'Card Nutritional Services',
			url: 'https://material-ui.com/static/images/cards/contemplative-reptile.jpg',
			width: 960,
			height: 540,
		},
		imageSm: null,
		imageMd: null,
	},
	detailsDescriptionTitle: 'What is Acupuncture?',
	detailsDescription: `{
		"nodeType": "document",
		"data": {
		  "target": null
		},
		"content": [
		  {
			"nodeType": "paragraph",
			"data": {
			  "target": null
			},
			"content": [
			  {
				"nodeType": "text",
				"data": {
				  "target": null
				},
				"value": "Acupuncture is an ancient form of Traditional Chinese Medicine. It has become widely used in the U.S. today. It is thought to help balance the flow of energy along pathways throughout your body. Placing fine needles at certain points along these pathways is thought to remove blockages. ",
				"marks": []
			  },
			  {
				"nodeType": "text",
				"data": {
				  "target": null
				},
				"value": "This may help rebalance the flow of energy. And this, in turn, may help ease pain and allow healing. Acupuncture is used to treat a wide range of health issues such as back, neck, and joint pain, nausea, headaches, and more.",
				"marks": [
				  {
					"type": "italic"
				  }
				]
			  }
			]
		  }
		]
	  }
	  `,
	detailsContentTitleImageWidget: [
		{
			title: 'Other Points to Consider',
			content: `{
				"nodeType": "document",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "You should expect the acupuncturist’s office staff to treat you with courtesy. When you call, are they prompt and professional? Do they answer your questions? Do they help set future appointments? Will you be comfortable working with the practitioner and his or her staff?\\r\\n\\r\\nAfter asking the questions listed above and meeting the practitioner and office staff, think about the answers you received. Does the acupuncturist’s approach to your healthcare seem like it will work for you? If so, you can feel comfortable that you have made an informed choice.",
						"marks": []
					  }
					]
				  }
				]
			  }
			`,
		},
		{
			title: 'Your Checklist',
			content: `{
				"nodeType": "document",
				"data": {
				  "target": null
				},
				"content": [
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "As you can see, there are many factors to think about when choosing an acupuncture professional. You deserve the best care possible. So do some research and ask questions. Most of all, take the time you need to make a choice you feel good about. Look for an acupuncturist who:\\r\\n\\r",
						"marks": []
					  }
					]
				  },
				  {
					"nodeType": "unordered-list",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "list-item",
						"data": {
						  "target": null
						},
						"content": [
						  {
							"nodeType": "paragraph",
							"data": {
							  "target": null
							},
							"content": [
							  {
								"nodeType": "text",
								"data": {
								  "target": null
								},
								"value": "Is licensed or certified to practice in your state",
								"marks": []
							  }
							]
						  }
						]
					  },
					  {
						"nodeType": "list-item",
						"data": {
						  "target": null
						},
						"content": [
						  {
							"nodeType": "paragraph",
							"data": {
							  "target": null
							},
							"content": [
							  {
								"nodeType": "text",
								"data": {
								  "target": null
								},
								"value": "Treats you with respect and professionalism",
								"marks": []
							  }
							]
						  }
						]
					  },
					  {
						"nodeType": "list-item",
						"data": {
						  "target": null
						},
						"content": [
						  {
							"nodeType": "paragraph",
							"data": {
							  "target": null
							},
							"content": [
							  {
								"nodeType": "text",
								"data": {
								  "target": null
								},
								"value": "\\rListens well to your health concerns",
								"marks": []
							  }
							]
						  }
						]
					  },
					  {
						"nodeType": "list-item",
						"data": {
						  "target": null
						},
						"content": [
						  {
							"nodeType": "paragraph",
							"data": {
							  "target": null
							},
							"content": [
							  {
								"nodeType": "text",
								"data": {
								  "target": null
								},
								"value": "Answers your questions in a way that you can understand",
								"marks": []
							  }
							]
						  }
						]
					  },
					  {
						"nodeType": "list-item",
						"data": {
						  "target": null
						},
						"content": [
						  {
							"nodeType": "paragraph",
							"data": {
							  "target": null
							},
							"content": [
							  {
								"nodeType": "text",
								"data": {
								  "target": null
								},
								"value": "\\rMakes every effort to help you improve your health",
								"marks": []
							  }
							]
						  }
						]
					  },
					  {
						"nodeType": "list-item",
						"data": {
						  "target": null
						},
						"content": [
						  {
							"nodeType": "paragraph",
							"data": {
							  "target": null
							},
							"content": [
							  {
								"nodeType": "text",
								"data": {
								  "target": null
								},
								"value": "\\rRefers you to specialists as needed",
								"marks": []
							  }
							]
						  }
						]
					  }
					]
				  },
				  {
					"nodeType": "paragraph",
					"data": {
					  "target": null
					},
					"content": [
					  {
						"nodeType": "text",
						"data": {
						  "target": null
						},
						"value": "",
						"marks": []
					  }
					]
				  }
				]
			  }
			`,
		},
	],
	detailsQuestionAnswerWidgetTitle: 'Questions you may have',
	detailsQuestionAnswerWidget: [
		{
			question: 'What training, certification, and experience do you have?',
			answer: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Most states call for acupuncturists to have a state or national license. If there is a licensing board in your state, you should make sure the practitioner is licensed. Then ask the acupuncturist if they have a specialty and what that is. Also ask how many years of experience he or she has.","marks":[]}]}]}`,
		},
		{
			question: 'How can you help me with my health issues?',
			answer: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Find out what kind of treatment will be offered. Will acupuncture be used? Acupuncture treatment often uses very fine, single-use needles. These are put into the skin at certain points on the body. Depending on your health issue, other services may be recommended. These may include:\\n- Chinese herbs\\n- Electro-stimulation (at a mild level to the needles or flat on the skin)\\n- Moxibustion (using a heated herb on the outside of the body)\\n- Acupressure (pressure applied to acupuncture points without needles)\\n- Cupping (mild suction tools)\\n- Tui Na or other TCM massages\\n- Special exercises to do at home\\n- TCM food plan advice","marks":[]}]},{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Be sure to ask questions to learn more about each of these services and how they may help you.","marks":[]}]}]}`,
		},
		{
			question:
				'Can you tell me about the benefits and risks of my treatment options?',
			answer: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Your acupuncturist will talk with you about your treatment options. He or she will explain the benefits and risks of each one. Be sure to let the practitioner know about any concerns you have.","marks":[]}]}]}`,
		},
	],
	detailsAuthor: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"John and Doe et al.","marks":[]}]},{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"","marks":[]}]}]}`,
	detailsReferences: `{"nodeType":"document","data":{"target":null},"content":[{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Mayo Clinic. (2015). Acupuncture. Retrieved from http://www.mayoclinic.org/tests-procedures/acupuncture/basics/definition/prc-2015","marks":[]}]},{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Mayo Clinic. (2010). Acupuncture. Retrieved from http://www.mayoclinic.org/tests-procedures/acupuncture/basics/definition/prc-2010","marks":[]}]},{"nodeType":"paragraph","data":{"target":null},"content":[{"nodeType":"text","data":{"target":null},"value":"Mayo Clinic. (2020). Acupuncture. Retrieved from http://www.mayoclinic.org/tests-procedures/acupuncture/basics/definition/prc-2020","marks":[]}]}]}`,
};

export const vendorDetailsSinglePromoCode = {
	...vendorDetails,
	promoCodeType: 'unique',
	promoCode: '12345',
	vendorLink: 'https://www.fitbit.com/global/us/store/choosehealthy',
};

export const vendorDetailsFitbitPromoCode = {
	...vendorDetails,
	promoCodeType: 'unique',
	cardTitle: 'Fitbit',
	promoCode: '12345',
	vendorLink: 'https://www.fitbit.com/global/us/store/choosehealthy',
};

export const vendorDetailsHowToDescriptionFromContentful = {
	...vendorDetailsFitbitPromoCode,
	howToSectionStep1CustomText:
		'This promoCode description is entered in contentful.',
};
export const vendorDetailsPromoCodeRunOut = {
	...vendorDetails,
	promoCode: '',
	promoCodeType: 'unique',
	vendorLink: 'https://www.fitbit.com/global/us/store/choosehealthy',
};
